import React from 'react';
import { WalletIcon, ShieldAlertIcon, MapIcon, HelpCircleIcon } from 'lucide-react';
import { Section, SectionHeading } from './shared';
// 06 — EMPATHY / PROBLEM SECTION · [Conversion] [Branding]
// Calm, respectful, non-dramatic. Four concerns.
const concerns = [{
  icon: WalletIcon,
  title: 'Uncertainty about income',
  body: 'Not knowing how bills, rent or a mortgage will be covered while you are unable to work.'
}, {
  icon: ShieldAlertIcon,
  title: 'Pressure from insurers or employers',
  body: 'Feeling rushed into decisions, or unsure whether what you are being told is in your interest.'
}, {
  icon: MapIcon,
  title: 'Difficulty understanding the process',
  body: 'Legal language, forms and timeframes can be hard to follow when you are also recovering.'
}, {
  icon: HelpCircleIcon,
  title: 'Concern about making the wrong decision',
  body: 'Worrying that a single early choice could affect your options later on.'
}];
export function EmpathySection() {
  return <Section className="bg-canvas" data-id="element-94">
      <SectionHeading eyebrow="We understand" title="An Injury Can Affect More Than Your Health" data-id="element-95" />

      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2" data-id="element-96">
        {concerns.map(c => {
        const Icon = c.icon;
        return <div key={c.title} className="rounded-card border border-ink/5 bg-paper p-7 shadow-card transition-transform duration-200 hover:-translate-y-0.5" data-id="element-97">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-btn bg-signal/10 text-signal" data-id="element-98">
                <Icon aria-hidden="true" className="h-5 w-5" strokeWidth={1.75} data-id="element-99" />
              </span>
              <h3 className="mt-4 text-h4 font-semibold text-ink" data-id="element-100">{c.title}</h3>
              <p className="mt-2 text-body text-slate" data-id="element-101">{c.body}</p>
            </div>;
      })}
      </div>

      <p className="mt-12 max-w-2xl font-serif text-h3 leading-[1.3] text-forest" data-id="element-102">
        You do not need to understand the legal system before asking for advice.
      </p>
    </Section>;
}